export default {
    en: {
        portraitLibrary: 'Portrait Library',
        vehicleLibrary: 'Vehicle Library',
        portraitLibraryInputHolder: 'Portrait Library Name',
        vehicleLibraryInputHolder: 'Vehicle Library Name',
        bodyLibraryInputHolder: 'Body library Name',
        portraitLibraryNameInputHolder: 'Please enter portrait library name',
        bodyLibraryNameInputHolder: 'Please enter body library name',
        portraitInputHolder: 'Name/IC Card',
        vehicleInputHolder: 'Vehicle Feature/Owner Name/Owner ID',
        vehicleLibraryNameInputHolder: 'Please enter vehicle library name',
        newLibrary: 'New Library',
        editLibrary: 'Edit Library',
        portraitLibraryName: 'Portrait Library Name',
        portraitNumber: 'Portrait Number',
        vehicleNumber: 'Vehicle Number',
        bodyNumber: 'Body Number',
        status: 'Status',
        libraryName: 'Library Name',
        createdBy: 'Created By',
        updatedAt: 'Updated At',
        action: 'Action',
        total: 'Total {msg} Items',
        enable: 'Enable',
        enabled: 'Enabled',
        disabled: 'Disabled',
        disabledSuccessfully: 'Disabled Successfully',
        enabledSuccessfully: 'Enabled Successfully',
        deletedSuccessfully: 'Deleted Successfully',
        createSuccessfully: 'Created Successfully',
        editSuccessfully: 'Edit Successfully',
        tip: 'Tip',
        deletePortraitLibTip: 'Are you sure to delete the portrait library? Cannot recover after deletion',
        deleteBodyLibTip: 'Are you sure to delete the body library? Cannot recover after deletion',
        deleteVehicleLibTip: 'Are you sure to delete the vehicle library? Cannot recover after deletion',
        deleteVehicleTip: 'Are you sure to delete the selected vehicles? Cannot recover after deletion',
        deletePortraitTip: 'Are you sure to delete the selected portraits? Cannot recover after deletion',
        deleteBodyTip: 'Are you sure to delete the selected bodys? Cannot recover after deletion',
        name: 'Name',
        new: 'New',
        singlePortrait: 'Single Portrait',
        singleVehicle: 'Single Vehicle',
        batchImport: 'Batch Import',
        idPhoto: 'ID Photo',
        at: 'At',
        by: 'By',
        from: 'From',
        supportFormat: 'supported format: {format}',
        lessThanSize: 'less than {size}M size',
        lessThanSizeMessage: 'The picture should be less than {size}M',
        uploadImagesCount: 'upload up to {count} images',
        portrait: 'Portrait',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        unknown: 'Unknown',
        fileName: 'File Name',
        validAll: 'Valid/All',
        reasonOfFailure: 'Reason of Failure',
        picture: 'Picture',
        plateNumber: 'Plate Number',
        brand: 'Brand',
        type: 'Type',
        color: 'Color',
        ownerName: 'Owner Name',
        ownerId: 'Owner ID',
        birthdate: 'Date of Birth',
        telephone: 'Telephone',
        nationality: 'Nationality',
        email: 'Email',
        department: 'Department',
        entryTime: 'Entry Time',
        identityNumber: 'ID',
        employeeID: 'Employee ID',
        passID: 'Pass ID',
        icCardNumber: 'IC Card',
        plateNumberColor: 'Plate Number Color',
        plateNumberType: 'Type of Plate Number',
        note: 'Note',
        selectAll: 'Select All',
        updatedBy: 'Updated By',
        batchOperation: 'Batch Operation',
        formatError: 'The file format is invalid',
        invalid: 'The portrait has expired and will not participate in control and retrieval operations, and the system will automatically delete relevant data after 7 days',
        expirationDate: 'Expiration Date',
        effectiveDate: 'Validity Period',
        permanentlyEffective: 'Permanent',
        custom: 'Custom ',
        pleaseSelectExpirationDate: 'Please select expiration date',
        bodyLibrary: 'Body Library',
        icCard: 'IC Card',
        faceLib: 'Face Library',
        portraitStatus: 'Portrait Status',
        passCodeStatus: 'Pass Code Status',
        all: 'All',
        valid: 'Valid',
        notExpired: 'Not Expired',
        expired: 'Expired',
        generated: 'Generated',
        notGenerated: 'Not Generated',
        passCode: 'Pass Code',
        regenerate: 'Regenerate',
        edit: 'Edit',
        validityPeriod: 'Validity period',
        effectiveTimes: 'Effective Times',
        PassCodeType: 'Pass Code Type',
        hello: 'Hello, {name}!',
        sexMan: 'Mr.',
        sexWoman: 'Ms.',
        unlimitedTimes: 'Unlimited Times',
        dynamic: 'Dynamic',
        static: 'Static',
        startDate: 'Start',
        endDate: 'End',
        effectiveTimesTips: 'Note：-1 is infinite. ',
    },
    zh: {
        bodyLibrary: '人体库',
        portraitLibrary: '人像库',
        vehicleLibrary: '车辆库',
        portraitLibraryInputHolder: '人像库名称',
        bodyLibraryInputHolder: '人体库名称',
        vehicleLibraryInputHolder: '车辆库名称',
        portraitLibraryNameInputHolder: '请输入人像库名称',
        bodyLibraryNameInputHolder: '请输入人体库名称',
        portraitInputHolder: '姓名/IC卡',
        vehicleInputHolder: '车辆特征/车主姓名/车主ID',
        vehicleLibraryNameInputHolder: '请输入车辆库名称',
        newLibrary: '新建库',
        editLibrary: '编辑库',
        portraitLibraryName: '人像库名称',
        portraitNumber: '人像数量',
        bodyNumber: '人体数量',
        vehicleNumber: '车辆数量',
        status: '状态',
        libraryName: '库名称',
        createdBy: '创建人',
        updatedAt: '更新时间',
        action: '操作',
        total: '总共 {msg} 条',
        enable: '启用',
        enabled: '启用',
        disabled: '停用',
        disabledSuccessfully: '停用成功',
        enabledSuccessfully: '启用成功',
        deletedSuccessfully: '删除成功',
        createSuccessfully: '创建成功',
        editSuccessfully: '编辑成功',
        tip: '提示',
        deletePortraitLibTip: '确定删除该人像库吗？删除后将无法复原。',
        deleteBodyLibTip: '确定删除该人体库吗？删除后将无法复原。',
        deleteVehicleLibTip: '确定删除该车辆库吗？删除后将无法复原。',
        deleteVehicleTip: '确定要删除所选车辆吗？删除后将无法复原。',
        deletePortraitTip: '确定要删除所选人像吗？删除后将无法复原。',
        deleteBodyTip: '确定要删除所选人体吗？删除后将无法复原。',
        name: '名称',
        new: '新建',
        singlePortrait: '单个人像',
        singleVehicle: '单个车辆',
        batchImport: '批量导入',
        idPhoto: 'ID 照片',
        at: '时间',
        by: '更新人',
        from: '人像库',
        supportFormat: '支持格式: {format}',
        lessThanSize: '图片应小于{size}M',
        lessThanSizeMessage: '上传图片应小于{size}M',
        uploadImagesCount: '最多上传{count}张',
        portrait: '人像',
        gender: '性别',
        male: '男性',
        female: '女性',
        unknown: '未知',
        fileName: '文件名',
        validAll: '有效/全部',
        reasonOfFailure: '失败原因',
        picture: '照片',
        plateNumber: '车牌号',
        brand: '品牌',
        type: '类型',
        color: '颜色',
        ownerName: '车主名称',
        ownerId: '车主 ID',
        birthdate: '出生日期',
        telephone: '电话',
        nationality: '国籍',
        email: '电子邮箱',
        department: '部门',
        entryTime: '入职时间',
        identityNumber: '身份号码',
        employeeID: '员工ID',
        passID: '通行证ID',
        icCardNumber: 'IC卡号码',
        note: '备注',
        plateNumberColor: '车牌颜色',
        plateNumberType: '车牌类型',
        selectAll: '全选',
        updatedBy: '更新人',
        batchOperation: '批量操作',
        formatError: '文件格式不符合要求',
        invalid: '人像已经过期，不参与布控、检索等操作，7天后系统自动删除相关数据。',
        expirationDate: '失效时间',
        effectiveDate: '有效时间',
        permanentlyEffective: '永久有效',
        custom: '自定义',
        pleaseSelectExpirationDate: '请选择失效日期',
        icCard: 'IC卡',
        faceLib: '人像库',
        portraitStatus: '人像状态',
        passCodeStatus: '通行码状态',
        all: '全部',
        valid: '有效',
        notExpired: '未到期',
        expired: '已过期',
        generated: '已生成',
        notGenerated: '未生成',
        passCode: '通行码',
        regenerate: '重新生成',
        edit: '编辑',
        validityPeriod: '有效时间',
        effectiveTimes: '有效次数',
        PassCodeType: '通行码类型',
        hello: '{name}, 你好！',
        sexMan: '先生',
        sexWoman: '女士',
        unlimitedTimes: '无限次',
        dynamic: '动态',
        static: '静态',
        startDate: '开始时间',
        endDate: '结束时间',
        effectiveTimesTips: '-1代表无通行次数限制'
    },
};
